/** Circuit mark path — matches Figma "Circuit Mark" / chat-widget CircuitIcon. */
const CIRCUIT_MARK_PATH =
  'M6.34669 9.50435C6.05297 9.50435 5.83914 9.22416 5.91472 8.93905L6.98818 0.333539C7.07728 -0.00134207 7.4945 -0.113174 7.73721 0.133225L12.4434 4.46763C12.5552 4.58069 12.5988 4.74536 12.5576 4.89959L11.9991 9.50497H6.34669V9.50435ZM11.9997 9.50435L10.27 23.5245C10.2012 24.0247 10.9134 24.2115 11.1917 23.6824L18.0276 10.1993C18.2211 9.90007 18.0079 9.50435 17.6534 9.50435H12.0003H11.9997Z';

const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Creates the 32×32 Circuit mark SVG used inside the launcher bubble.
 *
 * Accessibility: the SVG is `aria-hidden` because the parent `<button>` already
 * carries a label (`aria-label="Open chat"`); duplicating it on the icon would
 * make screen readers announce twice. The `<title>` is provided regardless so
 * mouse users get a tooltip on hover, and so any AT that ignores `aria-hidden`
 * still has a meaningful description (defense-in-depth).
 */
export function createCircuitMarkIcon(size = 32): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  svg.setAttribute('role', 'img');

  const title = document.createElementNS(SVG_NS, 'title');
  title.textContent = 'Circuit';
  svg.appendChild(title);

  const path = document.createElementNS(SVG_NS, 'path');
  path.setAttribute('fill-rule', 'evenodd');
  path.setAttribute('clip-rule', 'evenodd');
  path.setAttribute('d', CIRCUIT_MARK_PATH);
  path.setAttribute('fill', 'white');
  svg.appendChild(path);

  return svg;
}
